import { HelmetProvider } from "react-helmet-async";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Container from "./Container";
import ErrorFallback from "./Error";
import Images from "./ImageList";
import About from "./routes/About";
import Cards from "./routes/Cards";
import Contact from "./routes/Contact";
import Home from "./routes/Home";
import ImageOriginal from "./routes/ImageOriginal";
import Originals from "./routes/Originals";
import Prints from "./routes/Prints";

const App = () => {
  const routes = [
    {
      path: "/",
      element: (
        <Container title="Home">
          <Home />
        </Container>
      ),
      errorElement: <ErrorFallback />, // No need to pass props
    },
    {
      path: "/originals",
      element: (
        <Container title="Originals">
          <Originals />
        </Container>
      ),
    },
    {
      path: "/prints",
      element: (
        <Container title="Prints">
          <Prints />
        </Container>
      ),
    },
    {
      path: "/cards",
      element: (
        <Container title="Cards">
          <Cards />
        </Container>
      ),
    },
    {
      path: "/about",
      element: (
        <Container title="About">
          <About />
        </Container>
      ),
    },
    {
      path: "/contact",
      element: (
        <Container title="Contact">
          <Contact />
        </Container>
      ),
    }
  ];

  Images.forEach((element) => {
    routes.push({
      path: `/originals/${element.id}`,
      element: (
        <Container title={"Originals - " + element.title}>
          <ImageOriginal {...element} />
        </Container>
      ),
    });
  });

  const router = createBrowserRouter(routes);

  return (
    <HelmetProvider>
      <div className="App">
          <RouterProvider router={router} />
      </div>
    </HelmetProvider>
  );
};

export default App;
